import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { CustomDomain, RequestResponse } from '@/types';

function isMissingDomainError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return /not found|no custom domain|does not have a custom domain|cannot get/i.test(
    error.message
  );
}

/** Current custom domain for the authenticated business, if any. */
export const fetchStoreCustomDomain =
  async (): Promise<CustomDomain | null> => {
    try {
      const response = await axiosInstance.get<
        RequestResponse<CustomDomain | null>
      >(endpoints.storeCustomDomain);
      return response.data.data ?? null;
    } catch (error) {
      if (isMissingDomainError(error)) {
        return null;
      }
      throw error;
    }
  };
